import React, { useEffect, useState } from 'react';
import { Box, Typography, Card, CardContent, Avatar, Divider, CircularProgress } from '@mui/material';
import axios from 'axios';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import { useParams } from 'react-router-dom';
import { callAPI, Method } from '../../commonFunctions/CommonFunctions';
import SectionHeader from '../components/header';
import { Header } from '../../Components/Header/Header';

type UserRef = {
    name: string;
};

type ActivityLogEntry = {
    action: string;
    by: {
        id: UserRef;
        role: 'admin' | 'district' | 'block' | 'cds';
    };
    message: string;
    date: string;
};

const roleColors = {
    admin: '#3D52A0',
    district: '#7091E6',
    block: '#ADBBDA',
    cds: '#EDE8F5',
};

const LoanActivityLog = () => {
    const { loanId } = useParams();

    const [loading, setLoading] = useState<boolean>(true);
    const [logs, setLogs] = useState<ActivityLogEntry[]>([]);

    useEffect(() => {
        const fetchLogs = async () => {
            try {
                const res = await callAPI(`loans/log/activity/${loanId}`, Method.GET);
                setLogs(res.activityLog);
            } catch (err) {
                console.error('Failed to load activity log:', err);
            } finally { setLoading(false) }
        };
        fetchLogs();
    }, [loanId]);

    if (loading) {
        return (

            <Box
                height="100vh"
                display="flex"
                flexDirection="column"
                alignItems="center"
                justifyContent="center"
            >
                <CircularProgress color='inherit' />
            </Box>
        )
    }

    return (
        <Box>
            <Header id={"header"} title='Loan Activity Log' type='light' isBackButton />
            {logs.length === 0 && <Typography>No activity recorded yet.</Typography>}

            {logs.map((log, index) => (
                <Card
                    key={index}
                    sx={{
                        mb: 2,
                        mt: 2,
                        borderLeft: `5px solid ${roleColors[log.by?.role] || '#4AD16F'}`,
                        backgroundColor: '#f9f9f9',
                    }}
                >
                    <CardContent>
                        <Box display="flex" alignItems="center" gap={2}>
                            <Avatar sx={{ bgcolor: roleColors[log.by?.role] || '#a71a68' }}>
                                {log.by?.role?.[0]?.toUpperCase()}
                            </Avatar>
                            <Box>
                                <Typography variant="subtitle2">
                                    {log.by?.id?.name || 'Unknown User'} ({log.by?.role})
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {log.message}
                                </Typography>
                            </Box>
                        </Box>
                        <Divider sx={{ my: 1 }} />
                        <Box display="flex" alignItems="center" gap={1}>
                            <AccessTimeIcon fontSize="small" />
                            <Typography variant="caption">
                                {new Date(log.date).toLocaleString()}
                            </Typography>
                        </Box>
                    </CardContent>
                </Card>
            ))}
        </Box>
    );
};

export default LoanActivityLog;